export default class PropostaBanco {
  constructor () {
    this.identificacaoFiscal = null
    this.tipoProposta = null
  }
}
